import Icon from './Icon';

export default Icon;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/icon/index.js
// module id = 386
// module chunks = 0